export default __webpack_public_path__ + "static/powerpod-b88bc50c27c4422c1eac9562437f97bf.svg";